module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU4NS40IDI3OC42YTQ4IDQ4IDAgMCAxIDQ4IDQ4djM3MC44YTQ4IDQ4IDAgMCAxLTgxLjkgMzMuOWwtMTg1LjQtMTg1LjNhNDggNDggMCAwIDEgMC02Ny45bDE4NS40LTE4NS40YTQ4IDQ4IDAgMCAxIDMzLjktMTR6IG0tMTYgODYuNkw0MjIuNiA1MTJsMTQ2LjggMTQ2Ljd2LTI5My41eiIgZmlsbD0iIzAiIHAtaWQ9IjkyOCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret left-outlined.svg
// module id = QSUu
// module chunks = 73